import React, { useEffect, useState } from "react";
import { FaPlay, FaPause } from "react-icons/fa";

interface TimerWithPausePlayProps {
  timeInMinutes?: number; // Optional custom timer duration
  onExit?: () => void; // Optional callback for the Exit button
}

const TimerWithPausePlay: React.FC<TimerWithPausePlayProps> = ({
  timeInMinutes = 2, // Default to 2 minutes
  onExit,
}) => {
  const [timeLeft, setTimeLeft] = useState(timeInMinutes * 60); // Convert minutes to seconds
  const [isRunning, setIsRunning] = useState(true);

  // Timer logic
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    if (isRunning && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isRunning, timeLeft]);

  // Format timeLeft to MM:SS
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  // Handle play/pause toggle
  const handleToggle = () => {
    setIsRunning(!isRunning);
  };

  // Handle reset timer
  const handleReset = () => {
    setTimeLeft(timeInMinutes * 60); // Reset to initial duration
    setIsRunning(true); // Start timer immediately
  };

  return (
    <>
      {/* Freeze overlay */}
      {!isRunning && (
        <div 
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.8)", 
            zIndex: 0,
          }}
        ></div>
      )}

      {/* Top section: Timer, Button, Exit */}
      <div className="bg-white rounded py-2 col-4"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "6.25px 20px",
          borderRadius: "12px",
          zIndex: 0, // Stays above the overlay
          width: "100%",
        }}
      >
        {/* Timer */}
        <div className="timer">Timer: <span className="fw-bold">{formatTime(timeLeft)}</span></div>

        {/* Circular Play/Pause Button */}
        <button
          id="toggle-button"
          onClick={handleToggle}
          className="TimerCircular"
        >
          {isRunning ? <FaPause /> : <FaPlay />}
        </button>

        {/* Exit Button */}
        <div
          className="TimerExit border-start fw-medium"
          onClick={onExit || handleReset} // Call onExit if provided, else reset timer
        >
          Exit
        </div>
      </div>
    </>
  );
};

export default TimerWithPausePlay;
